{
  "title": "Skills",
  "subtitle": "Reusable instruction templates for your agents",
  "new": "New skill",
  "new_title": "New skill",
  "edit_title": "Edit skill: {{name}}",
  "delete_confirm": "Really delete skill \"{{name}}\"?",
  "section_user": "Your skills",
  "section_user_empty": "No user skills yet.",
  "section_system": "System skills",
  "section_system_empty": "No system skills installed.",
  "name": "Name",
  "name_invalid": "Invalid — only a-z, 0-9, _ and -, max 50 chars.",
  "name_immutable": "Name cannot be changed after creation.",
  "description": "Description",
  "description_placeholder": "What is this skill about?",
  "when_to_use": "When to use?",
  "when_to_use_hint": "Tells the AI in one sentence when to load this skill.",
  "when_to_use_placeholder": "e.g. 'When the user asks for code review'",
  "tools_required": "Required tools (comma-separated)",
  "body": "Instructions (Markdown)",
  "body_placeholder": "Instructions the agent gets when loading…",
  "sources": "Sources / URLs",
  "sources_hint": "URLs (forums, APIs, docs) the agent can fetch via fetch_url. Auth is auto-attached when a credential profile is set.",
  "source_description_placeholder": "Source description (optional)",
  "source_auth_placeholder": "Profile name",
  "source_auth_hint": "Optional: name of a credential profile from /credentials. Forces this auth on fetch_url.",
  "source_add": "Add source",
  "agent_tab_subtitle": "{{count}} skills available for this agent",
  "agent_tab_empty": "No skills available — create one under /skills or here.",
  "agent_tab_edit": "Edit",
  "agent_tab_on": "on",
  "agent_tab_off": "off",
  "project_title": "Project skills",
  "project_subtitle": "Shared library: every agent working in this project sees these skills — project agent, specialists and buddy/master when the project is selected.",
  "project_empty": "No project skills yet. The project agent can create them via write_skill, or you add one here.",
  "project_read_only": "You only have read access to this project.",
  "project_load_error": "Project skills could not be loaded."
}
